import { render, staticRenderFns } from "./IconGridCard.vue?vue&type=template&id=21ea024a"
import script from "./IconGridCard.vue?vue&type=script&lang=js"
export * from "./IconGridCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports